// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2NPZT","footer":"ReportModalFilter_footer__18VXB"};